// extracted by mini-css-extract-plugin
export default {"link":"ZP-z","disabled":"_P-z"};